import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { Patient } from './patientDetailSlice'

interface PatientListState {
  patients: Patient[]
  loading: boolean
  error: string | null
}

const initialState: PatientListState = {
  patients: [],
  loading: false,
  error: null,
}

export const fetchPatients = createAsyncThunk('patientList/fetchAll', async () => {
  const res = await fetch('/.netlify/functions/patients')
  if (!res.ok) throw new Error('Failed to fetch patients')
  return res.json() as Promise<Patient[]>
})

export const createPatient = createAsyncThunk(
  'patientList/create',
  async (data: {
    name: string
    species: string
    breed: string
    date_of_birth: string | null
    weight: number | null
    weight_unit: string
    sex: string
    spay_neuter_status: boolean
    microchip_number: string
    allergies: string
    owner_name: string
    owner_phone: string
    owner_email: string
    notes: string
  }) => {
    const res = await fetch('/.netlify/functions/patients', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    if (!res.ok) throw new Error('Failed to create patient')
    return res.json() as Promise<Patient>
  }
)

const patientListSlice = createSlice({
  name: 'patientList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatients.pending, (state) => {
        if (state.patients.length === 0) state.loading = true
      })
      .addCase(fetchPatients.fulfilled, (state, action) => {
        state.patients = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(fetchPatients.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to load'
      })
      .addCase(createPatient.fulfilled, (state, action) => {
        state.patients.unshift(action.payload)
      })
  },
})

export default patientListSlice.reducer
